export default {
  name: 'marking--docM',
  apiService: 'shoes',
  apiPath: '/admin/doc_m',
  enums: {
    certType: ['CONFORMITY_CERTIFICATE', 'CONFORMITY_DECLARATION'],
  },
};
